import './index.scss'
import { useLayoutEffect, useRef } from 'react'
import gsap from "gsap";
// import DrawSVGPlugin from "gsap/DrawSVGPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const SkillsWord = () => {
  const skills = useRef<HTMLHeadingElement>(null)

  useLayoutEffect(() => {
    // gsap.registerPlugin(DrawSVGPlugin);

    const timeline = gsap.timeline({ paused:true, defaults: { ease: 'none' } })
      .fromTo(".skills",
        {
          drawSVG: '100% 100%',
        },       
        {
        drawSVG: "100%",
        duration: 2
      })

      ScrollTrigger.create({
          animation: timeline,
          trigger: skills.current,
          start: "top top",
          toggleActions: "play none none reverse", 
      });

  }, [])

  return (
    <div className="skills__word" ref={skills}>
        <svg id="a" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 339.29 73.3">
            <path className='letter skills' d="M48.46,21.79c-.2-.34-.92-.87-2.14-1.58-1.22-.71-2.75-1.48-4.58-2.29s-3.83-1.53-6.01-2.14c-2.17-.61-4.34-.92-6.52-.92-2.85,0-5.06,.49-6.62,1.47-1.56,.98-2.34,2.48-2.34,4.5,0,1.62,.59,2.9,1.78,3.84,1.19,.94,2.9,1.77,5.14,2.48,2.24,.71,4.99,1.53,8.25,2.47,4.61,1.21,8.62,2.68,12.01,4.4,3.39,1.72,5.99,3.93,7.79,6.62,1.8,2.7,2.7,6.27,2.7,10.72,0,4.04-.75,7.47-2.24,10.26-1.49,2.8-3.51,5.05-6.06,6.77s-5.45,2.96-8.7,3.74c-3.26,.78-6.62,1.16-10.08,1.16s-7.14-.36-10.84-1.07c-3.7-.71-7.25-1.73-10.64-3.05-3.39-1.32-6.52-2.93-9.37-4.83l7.33-14.56c.27,.34,1.15,.97,2.65,1.88,1.49,.92,3.34,1.87,5.55,2.85,2.2,.98,4.67,1.85,7.38,2.6,2.71,.75,5.46,1.12,8.25,1.12,2.99,0,5.21-.46,6.67-1.39,1.46-.93,2.19-2.23,2.19-3.89,0-1.82-.76-3.24-2.29-4.25-1.53-1.01-3.6-1.92-6.21-2.73-2.61-.81-5.62-1.72-9.01-2.73-4.41-1.35-8.06-2.87-10.94-4.56-2.89-1.69-5.02-3.74-6.41-6.17-1.39-2.43-2.09-5.47-2.09-9.11,0-5.06,1.2-9.33,3.61-12.81,2.41-3.48,5.65-6.11,9.72-7.9C20.46,.9,24.91,0,29.73,0c3.39,0,6.67,.41,9.82,1.22s6.11,1.83,8.86,3.05c2.75,1.22,5.21,2.44,7.38,3.66l-7.33,13.84Z"/>
            <path className='letter skills' d="M67.7,72.79V.51h16.7V31.66L110.86,.51h18.73l-27.08,32.27,28.91,40.01h-19.14l-20.36-29.01-7.53,7.74v21.28h-16.7Z"/>
            <path className='letter skills' d="M136.82,72.79V.51h16.69V72.79h-16.69Z"/>
            <path className='letter skills' d="M167.36,72.79V.51h16.69V58.13h35.02v14.66h-51.71Z"/>
            <path className='letter skills' d="M226.91,72.79V.51h16.69V58.13h35.02v14.66h-51.71Z"/>
            <path className='letter skills' d="M329.83,21.79c-.2-.34-.92-.87-2.14-1.58-1.22-.71-2.75-1.48-4.58-2.29s-3.83-1.53-6.01-2.14c-2.17-.61-4.34-.92-6.52-.92-2.85,0-5.06,.49-6.62,1.47-1.56,.98-2.34,2.48-2.34,4.5,0,1.62,.59,2.9,1.78,3.84,1.19,.94,2.9,1.77,5.14,2.48,2.24,.71,4.99,1.53,8.25,2.47,4.61,1.21,8.62,2.68,12.01,4.4,3.39,1.72,5.99,3.93,7.79,6.62,1.8,2.7,2.7,6.27,2.7,10.72,0,4.04-.75,7.47-2.24,10.26-1.49,2.8-3.51,5.05-6.06,6.77s-5.45,2.96-8.7,3.74c-3.26,.78-6.62,1.16-10.08,1.16s-7.14-.36-10.84-1.07c-3.7-.71-7.25-1.73-10.64-3.05-3.39-1.32-6.52-2.93-9.37-4.83l7.33-14.56c.27,.34,1.15,.97,2.65,1.88,1.49,.92,3.34,1.87,5.55,2.85,2.21,.98,4.67,1.85,7.38,2.6,2.71,.75,5.46,1.12,8.25,1.12,2.99,0,5.21-.46,6.67-1.39,1.46-.93,2.19-2.23,2.19-3.89,0-1.82-.76-3.24-2.29-4.25-1.53-1.01-3.6-1.92-6.21-2.73-2.61-.81-5.62-1.72-9.01-2.73-4.41-1.35-8.06-2.87-10.94-4.56-2.89-1.69-5.02-3.74-6.41-6.17-1.39-2.43-2.09-5.47-2.09-9.11,0-5.06,1.2-9.33,3.61-12.81,2.41-3.48,5.65-6.11,9.72-7.9,4.07-1.79,8.52-2.68,13.33-2.68,3.39,0,6.67,.41,9.82,1.22,3.16,.81,6.11,1.83,8.86,3.05,2.75,1.22,5.21,2.44,7.38,3.66l-7.33,13.84Z" />
        </svg>
    </div>
  )
}

export default SkillsWord